var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"mr-0"},[_c('div',{staticClass:"box-body chart-responsive"},[_c('div',{staticStyle:{"height":"812px"}})])]),_c('my-modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModalVisible),expression:"isModalVisible"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }